import { createFileRoute, redirect } from '@tanstack/react-router'

type InsightsSearch = {
  metric?: string
}

// Capacity trends and health checks now live on the Monitor → Health tab.
// This route only exists so old links keep working.
export const Route = createFileRoute(
  '/_authenticated/instances/$instanceId/insights'
)({
  validateSearch: (search: Record<string, unknown>): InsightsSearch => {
    const metric = search.metric
    return {
      metric:
        typeof metric === 'string' && metric.trim().length > 0
          ? metric.trim()
          : undefined,
    }
  },
  beforeLoad: ({ params, search }) => {
    throw redirect({
      to: '/instances/$instanceId',
      params,
      search: { capacityMetric: search.metric },
    })
  },
})
